import { Button } from "@/components/ui/button"
import { Spinner } from "@/components/ui/spinner"
import { cn } from "@/utils/utils"
import type { ComponentProps } from "react"

type LoadingButtonProps = ComponentProps<typeof Button> & {
  loading?: boolean
}

function LoadingButton({
  loading = false,
  disabled,
  children,
  type = "button",
  className,
  ...props
}: LoadingButtonProps) {
  return (
    <Button
      type={type}
      disabled={disabled || loading}
      aria-busy={loading}
      aria-live={loading ? "polite" : undefined}
      className={cn("relative overflow-hidden", className)}
      {...props}
    >
      {children}
      {loading && (
        <>
          <div className="absolute inset-0 bg-background/50" />
          <div className="absolute inset-0 flex items-center justify-center">
            <Spinner className="size-5" />
          </div>
        </>
      )}
    </Button>
  )
}

export { LoadingButton }
